import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, Button, IconButton } from "@mui/material";

type GameReviewHeaderProps = {
  onBack: () => void;
  onPrevious: (() => void) | null;
  onNext: (() => void) | null;
};

export const GameReviewHeader = ({ onBack, onPrevious, onNext }: GameReviewHeaderProps) => (
  <Box
    component="nav"
    aria-label="Game navigation"
    sx={{
      display: "flex",
      alignItems: "center",
      height: 44,
      minWidth: 0,
      borderBottom: "1px solid",
      borderColor: "divider",
      flexShrink: 0,
    }}
  >
    <Button
      aria-label="Back to games"
      onClick={onBack}
      startIcon={<ArrowBackIcon fontSize="small" />}
      sx={{ height: 44, minWidth: 96, px: 1.25, borderRadius: 0, fontSize: ".65rem", fontWeight: 900 }}
    >
      GAMES
    </Button>
    <Box sx={{ ml: "auto", display: "flex", height: 44, borderLeft: "1px solid", borderColor: "divider" }}>
      <IconButton
        aria-label="Previous game"
        disabled={!onPrevious}
        onClick={onPrevious ?? undefined}
        sx={{ width: 44, height: 44, borderRadius: 0, borderRight: "1px solid", borderColor: "divider" }}
      >
        <ArrowBackIosNewIcon sx={{ fontSize: 15 }} />
      </IconButton>
      <IconButton
        aria-label="Next game"
        disabled={!onNext}
        onClick={onNext ?? undefined}
        sx={{ width: 44, height: 44, borderRadius: 0 }}
      >
        <ArrowForwardIosIcon sx={{ fontSize: 15 }} />
      </IconButton>
    </Box>
  </Box>
);
